/**
 * Karakuri suggest機能を管理するcomposable
 * 重複初期化を防ぎ、適切なクリーンアップを行う
 */
export const useKarakuri = () => {
  /**
   * Karakuri suggestを初期化する
   * @param targetElementId - 対象となる要素のID（デフォルト: "contact_form_suggest_area"）
   */
  const initializeKarakuri = (targetElementId: string = "contact_form_suggest_area") => {
    // 対象要素の存在確認
    const targetElement = document.getElementById(targetElementId)
    if (!targetElement) return

    // DOM属性で初期化済みかチェック
    if (targetElement.hasAttribute("data-karakuri-initialized")) return

    // Karakuri iframeが既に存在するかチェック
    const karakuriIframe = targetElement.querySelector('iframe[src*="faq.tential.jp/suggest"]')
    const hasKarakuriElements = karakuriIframe !== null

    // karakuri要素が存在せず、loadKrkrSuggest関数が利用可能な場合のみ初期化
    if (!hasKarakuriElements && window && typeof window.loadKrkrSuggest === "function") {
      try {
        window.loadKrkrSuggest()

        // DOM属性に初期化完了フラグを設定
        targetElement.setAttribute("data-karakuri-initialized", "true")
      } catch (error) {
        console.error("Failed to initialize Karakuri:", error)
      }
    }
  }

  return {
    initializeKarakuri,
  }
}
